// Copyright © 2025 CATTLEytics Inc.

import { Stack } from 'react-bootstrap';

import { VirtualizedBootstrapTable } from './VirtualizedBootstrapTable';

interface DynamicTableProps {
  data: any[];
  reportName?: string;
}

export function DynamicTable({ data }: DynamicTableProps): JSX.Element {
  // make headers into DataTableHeader[]
  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  return (
    <Stack gap={3}>
      <VirtualizedBootstrapTable data={data} />
    </Stack>
  );
}
